import { Setter } from "../../services/ComService"
import { parseStringFromServer } from "../../services/TextConverter"

export interface IUserItem {
  userId: number
  userEmail: string
  userName: string
  userInitials: string
}

interface IUserFkt extends IUserItem {
  id: number
  fkt: number
}

export type SalesContactTrafficLight = 'green' | 'yellowgreen' | 'yellow' | 'orange' | 'red'

export interface ICustomerItem {
  id: number
  name: string
  town?: string
  trainingCount: number
  coachingCount: number
  openTrainingCount: number
  lastSalesContact: string | null
  fkts: IUserFkt[]
}

export function salesContactTrafficLight(lastSalesContact: string | null, now = new Date()): SalesContactTrafficLight {
  if (!lastSalesContact) {
    return 'red'
  }
  const date = new Date(lastSalesContact)
  if (Number.isNaN(date.getTime())) {
    return 'red'
  }
  const days = (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24)
  if (days <= 7) {
    return 'green'
  }
  if (days <= 30) {
    return 'yellowgreen'
  }
  if (days <= 90) {
    return 'yellow'
  }
  if (days <= 365) {
    return 'orange'
  }
  return 'red'
}

export function salesContactTooltip(lastSalesContact: string | null): string {
  if (!lastSalesContact) {
    return 'Kein Vertriebskontakt'
  }
  const date = new Date(lastSalesContact)
  if (Number.isNaN(date.getTime())) {
    return 'Kein Vertriebskontakt'
  }
  return `Letzter Vertriebskontakt: ${date.toLocaleDateString('de-DE')}`
}

export const salesContactColors: Record<SalesContactTrafficLight, string> = {
  green: '#2e7d32',
  yellowgreen: '#9ccc65',
  yellow: '#fdd835',
  orange: '#fb8c00',
  red: '#e53935',
}

export class UserCustomerMatrixDTO {
  userId?: number
  customerId?: number
  fkt?: number
  limit: number = 1000
  page: number = 0
  customers: ICustomerItem[] = []
  users: IUserItem[] = []

  async getFromServer() {
    const body: {
      userId?: number
      customerId?: number
      fkt?: number
      limit: number
      page: number
    } = {
      limit: this.limit,
      page: this.page,
    }
    if (this.userId !== undefined) {
      body.userId = this.userId
    }
    if (this.customerId !== undefined) {
      body.customerId = this.customerId
    }
    if (this.fkt !== undefined) {
      body.fkt = this.fkt
    }
    const data = await Setter('userCustomerFkt', body) as {customers: ICustomerItem[]}
    this.customers = data.customers.map((c) => {
      return {
        ...c,
        name: parseStringFromServer(c.name),
        trainingCount: c.trainingCount || 0,
        coachingCount: c.coachingCount || 0,
        openTrainingCount: c.openTrainingCount || 0,
        lastSalesContact: c.lastSalesContact || null,
        fkts: (c.fkts || []).map((f) => ({
          ...f,
          userInitials: f.userInitials || initialsFromName(f.userName),
        })),
      }
    })
    // Get involved users:
    let users: IUserItem[] = []
    this.customers.forEach((c) => {
      c.fkts.forEach((f) => {
        if (!users.some((u) => u.userId === f.userId)) {
          users.push(f)
        }
      })
    })
    this.users = users
    return data
  }
  userInCustomer(userId: number, customerId: number) {
    return this.customers.find(c => c.id === customerId)?.fkts.some(f => f.userId === userId)
  }
}

function initialsFromName(name: string): string {
  const parts = (name || '').split(/\s+/).filter(Boolean)
  if (parts.length === 0) {
    return '-'
  }
  return parts.map(p => p[0]).join('').toUpperCase()
}
